<template>
    <div id="authorize">
        <v-row align="center" justify="center">
            <v-spacer />
            <v-col cols="8" lg="6">
                <h1 class="pb-4 primary--text text-align--center">
                    Welcome to Control Surface for Spotify
                </h1>
                <p class="pb-8">
                    <v-btn
                        color="#1DB954"
                        dark
                        block
                        @click="begin_spotify_auth_flow"
                    >
                        Sign In With Spotify
                    </v-btn>
                </p>

                <div>
                    <p class="text-size--small">
                        Control Surface for Spotify allows you to control your
                        Spotify account.
                    </p>
                    <p class="text-size--small secondary--text">
                        Control Surface for Spotify only supports music at this
                        time. Support for podcasts is on the roadmap.
                    </p>
                    <p class="text-size--small secondary--text">
                        This app gains limited access to your Spotify account.
                        This includes all public information regarding your
                        account, the ability to read and modify the playback
                        state, and the ability to read and modify your library.
                        The playback state is comprised of the playback controls
                        (play/pause, next, previous) and track information
                        information (name, artist(s), album, etc.). Your library
                        is your saved content.
                    </p>
                    <p class="text-size--small secondary--text">
                        This app does not store any of your data on any servers.
                        Your Spotify credentials are not ever sent to this app.
                        An authorization framework called OAuth2 is used. Read
                        more about OAuth2 on
                        <a
                            href="https://www.digitalocean.com/community/tutorials/an-introduction-to-oauth-2"
                            class="accent--text"
                            target="_blank"
                        >
                            DigitalOcean</a
                        >.
                    </p>
                </div>
            </v-col>
            <v-spacer />
        </v-row>
    </div>
</template>

<script>
export default {
    name: "Authorization",
    mounted() {
        let query_params = new URLSearchParams(window.location.search);
        if (query_params.get("code")) {
            this.get_oauth_tokens();
        } else if (
            this.$NODE_ENV === "development" &&
            !query_params.get("signout")
        ) {
            this.begin_spotify_auth_flow();
        }
    },
    methods: {
        begin_spotify_auth_flow: function() {
            let base_url = "https://accounts.spotify.com/authorize";
            let link =
                base_url +
                "?client_id=" +
                this.$information.client_id +
                "&response_type=code&redirect_uri=" +
                encodeURIComponent(this.$information.redirect_uri) +
                "&scope=" +
                encodeURIComponent(this.$information.scopes.join(" "));

            window.open(link, "_self");
        },
        store_spotify_credentials: function(response_data) {
            this.$spotify_credentials.access_token = response_data.access_token;
            this.$spotify_credentials.refresh_token =
                response_data.refresh_token;
            this.$spotify_credentials.expires_in = Number(
                response_data.expires_in
            );
            this.$router.push("/");
        },
        get_oauth_tokens: function() {
            let query_params = new URLSearchParams(window.location.search);
            if (query_params.get("code")) {
                this.$axios
                    .post(
                        "https://accounts.spotify.com/api/token",
                        this.$qs.stringify({
                            grant_type: "authorization_code",
                            code: query_params.get("code"),
                            redirect_uri: this.$information.redirect_uri
                        }),
                        {
                            headers: {
                                Authorization:
                                    "Basic " +
                                    btoa(
                                        this.$information.client_id +
                                            ":" +
                                            this.$information.client_secret
                                    ),
                                "Content-Type":
                                    "application/x-www-form-urlencoded"
                            }
                        }
                    )
                    .then(response => response.data)
                    .then(data => this.store_spotify_credentials(data))
                    .catch(error => {
                        if (error.response) {
                            if (
                                error.response.data.error_description.indexOf(
                                    "Invalid authorization code"
                                ) != -1
                            ) {
                                this.begin_spotify_auth_flow();
                            } else {
                                console.error(error);
                            }
                        } else {
                            console.error(error);
                        }
                    });
            }
        }
    }
};
</script>

<style scoped>
body {
    text-align: center;
    padding: 20px;
}
@media (min-width: 768px) {
    body {
        padding-top: 150px;
    }
}
body {
    font: 20px Helvetica, sans-serif;
    color: #333;
}
article {
    display: block;
    text-align: left;
    max-width: 650px;
    margin: 0 auto;
}
a {
    text-decoration: none;
}
a:hover {
    text-decoration: none;
}

i.v-icon#spotify-logo {
    margin-right: 10px;
}
</style>
